module.exports = __webpack_public_path__ + "static/media/13.64c34c64.jpg";